<template>
    <Modal>
        <template #title>
            <span> {{ t('dsa-info.title') }} </span>
        </template>

        <template #content>
            <div>
                <p class="text-sm font-subtitle-2 text-black">{{ t('dsa-info.sub_title') }}</p>
                <p class="text-sm font-subtitle-2">{{ t('dsa-info.why_title') }}</p>
                <br />
                <ul class="text-sm ml-8 list-disc">
                    <li>{{ t('dsa-info.why_points.text_1') }}</li>
                    <li>{{ t('dsa-info.why_points.text_2') }}</li>
                    <li>{{ t('dsa-info.why_points.text_3') }}</li>
                    <li>{{ t('dsa-info.why_points.text_4') }}</li>
                </ul>
            </div>
            <br />
            <div v-if="advertiserName">
                <p class="text-sm font-subtitle-2 text-black">{{ t('dsa-info.who_title') }}</p>
                <br />
                <ul class="text-sm ml-8 list-disc">
                    <li v-html="t('dsa-info.who_points.text_1', { advertiserName })"></li>
                    <li v-html="t('dsa-info.who_points.text_2', { advertiserName })"></li>
                </ul>
            </div>
        </template>
        <template #actions>
            <Btn
                color="primary"
                :label="t('dsa-info.button')"
                @click="close()"
            />
        </template>
    </Modal>
</template>

<script lang="ts">
import ModalMixin from '@mixins/modalMixin';
import Modal from '@components/Modal/Modal.vue';
import type { PropType } from 'vue';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'ModalDsaInfo',

    components: {
        Modal,
    },

    extends: ModalMixin,

    props: {
        /**
         * Properties of xandr advertiser.
         */
        advertiserData: {
            type: Object as PropType<Record<string, string>>,
            required: true,
            default: () => {},
        },
    },

    setup() {
        const { t } = useTranslation('dsa');
        return { t };
    },

    computed: {
        advertiserName(): unknown {
            return this.advertiserData?.advertiser_name;
        },
    },
};
</script>
